export default __webpack_public_path__ + "static/group-selection-c04448cf4b686d8be2cc2f64bbfa1469.png";